// *********************************************************************************************************map box**********************************************************

import React, { useRef, useEffect } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import { Box } from '@mui/material';
import start_mark from '../../assets/images/icons/marker/start_mark.svg';
import end_mark from '../../assets/images/icons/marker/end_mark.svg';
import noDataFound from '../../assets/images/nothing-found.svg';
import { useSelector } from 'react-redux';
import { Riple } from 'react-loading-indicators';
// import { routeMap } from 'utilities/common';

// Set your Mapbox access token
mapboxgl.accessToken = process.env.REACT_APP_MAP_KEY_TOKEN;

const CalculateMap = ({ route, taskAddress, showImg, routeMap }) => {
  const mapRef = useRef(null);
  const mapContainerRef = useRef(null);
  const markersRef = useRef([]);
  // taskloading
  const { taskloading = false } = useSelector(state => state.driverAnalyticsHyperDrive);

  useEffect(() => {
    if (!routeMap || routeMap?.length === 0) {
      return;
    }

    const updatedPoints = routeMap?.map(point => ({
      lat: point.latitude,
      lng: point.longitude
    }));

    const addressEndFlag = {
      lat: taskAddress?.latitude,
      lng: taskAddress?.longitude
    };

    // Initialize the map
    const map = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: 'mapbox://styles/mapbox/dark-v10',
      center: [updatedPoints[0].lng, updatedPoints[0].lat],
      zoom: 10
    });

    mapRef.current = map;

    // Add navigation controls
    map.addControl(new mapboxgl.NavigationControl());

    // When map loads, create the route
    map.on('load', () => {
      // Combine all points including the destination
      const allPoints = [...updatedPoints, addressEndFlag];

      // Create a GeoJSON line string
      const routeGeoJSON = {
        type: 'Feature',
        geometry: {
          type: 'LineString',
          coordinates: allPoints.map(point => [point.lng, point.lat])
        },
        properties: {}
      };

      // Add the route source and layer
      map.addSource('route', {
        type: 'geojson',
        data: routeGeoJSON
      });

      map.addLayer({
        id: 'route',
        type: 'line',
        source: 'route',
        layout: {
          'line-join': 'round',
          'line-cap': 'round'
        },
        paint: {
          'line-color': '#FFE37E',
          'line-width': 3,
          'line-opacity': 0.8
        }
      });

      // Add markers
      const startMarker = new mapboxgl.Marker({
        element: createCustomMarkerElement(start_mark)
      }).setLngLat([updatedPoints[0].lng, updatedPoints[0].lat]).addTo(map);

      const endMarker = new mapboxgl.Marker({
        element: createCustomMarkerElement(end_mark)
      }).setLngLat([addressEndFlag.lng, addressEndFlag.lat]).addTo(map);

      markersRef.current.push(startMarker, endMarker);

      // Fit bounds to the entire route
      const bounds = allPoints.reduce((bounds, point) => {
        return bounds.extend([point.lng, point.lat]);
      }, new mapboxgl.LngLatBounds([updatedPoints[0].lng, updatedPoints[0].lat], [updatedPoints[0].lng, updatedPoints[0].lat]));

      map.fitBounds(bounds, {
        padding: 50,
        maxZoom: 14
      });
    });

    // Cleanup function
    return () => {
      if (mapRef.current) {
        // Remove all markers
        markersRef.current.forEach(marker => marker.remove());
        markersRef.current = [];

        // Remove route layer and source if they exist
        if (map.getLayer('route')) map.removeLayer('route');
        if (map.getSource('route')) map.removeSource('route');

        map.remove();
        mapRef.current = null;
      }
    };
  }, [routeMap, taskAddress]);

  function createCustomMarkerElement(iconUrl) {
    const el = document.createElement('div');
    el.style.backgroundImage = `url(${iconUrl})`;
    el.style.width = '24px';
    el.style.height = '24px';
    el.style.backgroundSize = 'contain';
    return el;
  }

  return (
    <>
      {
        taskloading ?
          <div style={{ textAlign: "center" }}>
            <Riple color='#3135cc' size='medium' text='' textColor='' />
          </div>
          :
          <>  {routeMap?.length === 0 ? (
            <div className='d-flex align-item-center flex-column gap-3 jc-center p-4'>
              {!showImg && (
                <Box textAlign='center' className='no-data-found'>
                  <img style={{ maxWidth: '120px' }} src={noDataFound} alt='No Route Found' />
                  <p className='text-12'><strong>No Route Found</strong></p>
                </Box>
              )}
            </div>
          ) : (
            <div style={{
              position: 'relative',
              width: '100%',
              height: '100%',
              borderRadius: '6px',
              overflow: 'hidden'
            }}>
              {(routeMap?.length === 0 || routeMap === undefined) ? '' : (
                <div
                  ref={mapContainerRef}
                  style={{
                    width: '100%',
                    height: route === 'detailRoute' ? '200px' :
                      route === 'taskRoute' ? '500px' : '300px'
                  }}
                />
              )}
            </div>
          )}
          </>
      }

    </>
  );
};

export default CalculateMap;